import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'

const skin = era.skin('widgets/Popups/AnnouncementPopup/')

AnnouncementPopup.displayName = 'AnnouncementPopup'
export function AnnouncementPopup(): JSX.Element | null {
  return <ui.RenderSkin from={skin} name='announcementPopup' />
}
